<template>
  <v-hover>
    <v-expansion-panel slot-scope="{ hover }" :class="[`elevation-${hover ? 2 : 0}`, 'mt-0', 'comms-room', { 'message-deleting': isDeleting }]" expand
      v-model="expansionPanelState">
      <v-expansion-panel-content hide-actions style="background:none !important;">
        <template v-slot:header>
          <div class="header">
            <div class="icon">
              <v-icon color="secondary">email</v-icon>
            </div>
            <div class="from">
              <span class="last-sender body-1 opacity-54">{{ messageData.from.displayName || messageData.from.email }}</span>
            </div>
            <div class="subject">
              <div class="conversation-header-title">
                <h4 class="unread d-inline-block">
                  {{ messageData.subject }}
                </h4>
              </div>
            </div>
            <div class="sentiment-pill">
              <sentiment-pill :sentimentScore=messageData.sentimentScore
                :sentimentMagnitude=messageData.sentimentMagnitude />
            </div>
            <div class="actions">
              <v-icon v-if="hasAttachment" size="20" class="mr-2" color="secondary" style="vertical-align:middle">
                attach_file
              </v-icon>
              <v-tooltip v-if="hasCaseAttached" class="action-button" top color="secondary">
                <v-btn slot="activator" icon class="ml-0 mr-0 d-inline-block" @click.stop="goToCase()">
                  <v-icon color="secondary">folder_open</v-icon>
                </v-btn>
                <span>Go to attached case</span>
              </v-tooltip>
              <v-tooltip v-if="!hasCaseAttached" class="action-button" top color="secondary">
                <v-btn icon slot="activator" class="ml-0 ma-0 d-inline-block" @click.stop="popout()">
                  <v-icon color="secondary">create_new_folder</v-icon>
                </v-btn>
                <span>Attach to a case</span>
              </v-tooltip>
              <v-tooltip v-if="isArchived" class="action-button" top color="secondary">
                <v-btn icon slot="activator" class="ma-0 d-inline-block" @click.stop="archive()">
                  <v-icon color="secondary">unarchive</v-icon>
                </v-btn>
                <span>Un-archive</span>
              </v-tooltip>
              <v-tooltip v-if="!isArchived" class="action-button" top color="secondary">
                <v-btn icon slot="activator" class="ma-0 d-inline-block" @click.stop="archive()">
                  <v-icon color="secondary">archive</v-icon>
                </v-btn>
                <span>Archive</span>
              </v-tooltip>

              <v-tooltip class="action-button" top color="secondary">
                <v-btn slot="activator" icon class="ml-0 ma-0 d-inline-block" @click.stop="dialogForward = true">
                  <v-icon color="secondary"
                    style=" -moz-transform: scaleX(-1);-webkit-transform: scaleX(-1);transform: scaleX(-1);-o-transform: scaleX(-1);">
                    reply
                  </v-icon>
                </v-btn>
                <v-dialog v-model="dialogForward" max-width="500">
                  <v-card class="pa-4">
                    <v-card-title class="pa-0 pb-2">
                      <h2>Forward this email</h2>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <p>This will forward this email and move it into your archive folder</p>
                      <v-text-field class="pt-2" persistent-hint box
                        hint="NB: Add multiple recipients by using a semi-colon between email addresses." label="To:"
                        v-model="forwardEmail">
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions class="ma-0 pa-0 pt-1">
                      <v-btn color="success" :disabled="!forwardEmailAdded" @click="forwardMessage()">
                        Send
                      </v-btn>
                      <v-btn @click="dialogForward = false" color="secondary">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <span>Forward</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <v-btn slot="activator" icon class="ma-0 d-inline-block" @click.stop="dialogDelete = true">
                  <v-icon color="secondary">delete</v-icon>
                </v-btn>
                <v-dialog v-model="dialogDelete" max-width="500">
                  <v-card class="pa-4">
                    <v-card-title class="pa-0 pb-2">
                      <h2>Delete Message</h2>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <p>Are you sure you want to delete this message?</p>
                    </v-card-text>
                    <v-card-actions class="ma-0 pa-0 pt-1">
                      <v-btn @click="deleteMessage()" color="error">Yes, delete this message</v-btn>
                      <v-btn @click="dialogDelete = false" color="secondary">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <span>Delete</span>
              </v-tooltip>
            </div>
            <div class="date">
              {{ sentTime }}
            </div>
          </div>


        </template>
        <v-flex xs12 px-0>
          <v-card class="elevation-0 pr-2 mt-0 pa-4 pt-0" style="background:rgba(255,255,255,1);">
            <v-layout column wrap>
              <div class="message-header">
                <div class="message-header-content">
                  <div class="message-header-info">
                    <div class="opacity-54 message-header-label">From:</div>
                    <div class="message-header-value">
                      <span :title="messageData.from.email || messageData.from.displayName">{{ formatFromEmail(messageData.from) }}</span>
                    </div>
                    <div v-if="messageData.recipients && messageData.recipients.length > 0" class="opacity-54 message-header-label recipients">To:</div>
                    <div v-if="messageData.recipients && messageData.recipients.length > 0" class="message-header-value recipients">
                      <span v-for="(recipient, index) in messageData.recipients" :key="index">
                        <span v-if="index > 0" class="d-inline-block mr-2">;</span>
                        <span class="d-inline-block">{{ formatRecipientEmail(recipient) }}</span>
                      </span>
                    </div>
                    <div class="opacity-54 message-header-label">Date:</div>
                    <div class="message-header-value">
                      <span>{{ formatDateTime(messageData.createdAt) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <v-card class="elevation-0">
                <v-layout row xs12 md12>
                  <v-flex class="px-0 pb-0 mx-20 my-2 pt-1" xs12 md12>
                    <MessageFrame :messageId="messageData.id" v-if="expansionPanelOpen" />
                  </v-flex>
                </v-layout>

              </v-card>
              <v-card v-if="nonInlineAttachmentsWithDetails.length > 0" class="elevation-0 mt-2">
                <v-card-title class="pa-2 pb-1">
                  <h4 class="subheading">Attachments</h4>
                </v-card-title>
                <v-card-text class="pa-2 pt-0">
                  <v-list dense class="attachment-list">
                    <v-list-tile v-for="attachment in nonInlineAttachmentsWithDetails" :key="attachment.id" :href="getAttachmentUrl(attachment)" target="_blank" class="pa-0 attachment-item">
                      <div class="attachment-icon-wrapper" :style="{ backgroundColor: getIconForMimeType(attachment.contentType, attachment.filename).color }">
                        <font-awesome-icon 
                          :icon="[getIconForMimeType(attachment.contentType, attachment.filename).iconSet, getIconForMimeType(attachment.contentType, attachment.filename).iconName]" 
                          class="attachment-icon"
                          size="lg"
                        />
                      </div>
                      <v-list-tile-content class="attachment-content">
                        <v-list-tile-title class="attachment-filename">
                          {{ attachment.filename }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="attachment-size">
                          {{ formatFileSize(attachment.size) }} • {{ attachment.contentType }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-card>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-hover>

</template>

<script>
import Helpers from "@/helpers.js"
import MessageFrame from "@/components/comms/MessageFrame.vue"
import { mapState } from 'vuex'
import SentimentPill from "@/components/comms/SentimentPill"
import { getIconForMimeType } from "@/lib/mimeTypeIcons.js"

export default {
  name: "comms-message",
  components: { MessageFrame, SentimentPill },
  props: {
    messageData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialogForward: false,
    dialogDelete: false,
    isArchived: false,
    forwardEmail: "",
    expansionPanelState: [false],
    isDeleting: false
  }),
  computed: {
    ...mapState({
      savedSearchId: state => state.cbroute.params.saved_search_id,
      userPreferences: state => state.currentUser.me.preferences
    }),
    sentTime() { return Helpers.formatTimeAsGmail(new Date(this.messageData.updatedAt), this.userPreferences.dateFormat) },
    hasCaseAttached() { return (this.messageData.conversation.case !== null) },
    hasAttachment() { return (this.nonInlineAttachments && this.nonInlineAttachments.length > 0) },
    nonInlineAttachments() {
      if (!this.messageData.attachments) return []
      return this.messageData.attachments.filter(att => !att.isInline)
    },
    nonInlineAttachmentsWithDetails() {
      return this.nonInlineAttachments.filter(att => att && att.url && att.filename)
    },
    expansionPanelOpen() {
      return this.expansionPanelState && this.expansionPanelState.length > 0 && this.expansionPanelState[0]
    }
  },
  created() {
    this.isArchived = this.messageData.archivedAt !== null
  },
  watch: {
    messageData: {
      handler(newData, oldData) {
        // Reset isDeleting if message data changes (e.g., component reused)
        if (oldData && newData && oldData.id !== newData.id) {
          this.isDeleting = false
        }
      },
      immediate: false
    }
  },
  beforeDestroy() {
    // Ensure isDeleting is reset when component is destroyed
    this.isDeleting = false
  },
  methods: {
    caseRoute: (caseId) => `/case/${caseId}/conversations`,
    goToCase() {
      if (this.messageData.conversation.case && this.messageData.conversation.case.id) {
        this.$router.push(this.caseRoute(this.messageData.conversation.case.id))
      }
    },
    async archive() {
      const data = { messageId: parseInt(this.messageData.id), markArchived: !this.isArchived }
      const success = await this.$store.dispatch("archiveMessage", data)
      if (success) {
        this.isArchived = !this.isArchived
      }
    },
    popout() {
      this.$store.dispatch("popoutMessage", { messageId: parseInt(this.messageData.id) })
    },
    forwardEmailAdded() {
      return (this.forwardEmail !== "")
    },
    attachToClipboard() {
      this.$store.dispatch("setClipboardCommsMessage", this.messageData)
    },
    forwardMessage() {
      this.dialogForward = false
      this.$store.dispatch("forwardMessage", { messageId: parseInt(this.messageData.id), email: this.forwardEmail })
    },
    async deleteMessage() {
      this.dialogDelete = false
      const messageIdToDelete = parseInt(this.messageData.id)
      this.isDeleting = true
      
      // Start fade-out animation and wait for it to complete
      await new Promise(resolve => setTimeout(resolve, 300))
      
      // Now remove from list and call API
      await this.$store.dispatch("deleteMessage", {
        messageId: messageIdToDelete,
        savedSearchId: this.savedSearchId
      })
      
      // Reset isDeleting before component is removed
      this.isDeleting = false
      
      // Reload to ensure consistency (the message is already removed optimistically)
      this.$emit("reload")
    },
    formatFromEmail(from) {
      if (!from) {
        return ""
      }
      return this.formatRecipientEmail(from)
    },
    formatRecipientEmail(recipient) {
      if (!recipient) {
        return ""
      }
      const email = recipient.email || ""
      const displayName = recipient.displayName || ""

      // If no email, return in standard format with "no-email-available"
      if (!email) {
        if (displayName) {
          return `${displayName} <no-email-available>`
        }
        return "no-email-available"
      }

      // If displayName exists and is different from email, show "Display Name <email>"
      if (displayName && displayName !== email) {
        return `${displayName} <${email}>`
      }

      // Otherwise, just show the email
      return email
    },
    formatDateTime(date) {
      return Helpers.formatDateTime(date)
    },
    isInboundMessage(message) {
      if (!message || !message.from) {
        return false
      }
      // Inbound messages have from.type !== "User" (e.g., "Custom" for external senders)
      // Outbound messages have from.type === "User"
      // If type is undefined, default to treating as outbound (safer default)
      if (message.from.type === undefined || message.from.type === null) {
        return false
      }
      return message.from.type !== "User"
    },
    getMessageDisplay(message) {
      if (!message) {
        return ""
      }
      // Check if message.from exists - for some send failures, from may be undefined
      if (!message.from) {
        // If from is missing, try to show recipients if available
        if (message.recipients && message.recipients.length > 0) {
          const recipientAddresses = message.recipients
            .map(recipient => this.formatRecipientEmail(recipient))
            .filter(addr => addr)
            .join(", ")
          return recipientAddresses ? `To: ${recipientAddresses}` : "To: (no recipients)"
        }
        return "(no sender/recipient info)"
      }
      if (this.isInboundMessage(message)) {
        // For inbound messages, show "From: [from address]"
        const fromAddress = this.formatFromEmail(message.from)
        return fromAddress ? `From: ${fromAddress}` : ""
      } else {
        // For outbound messages, show "To: [to address]"
        if (!message.recipients || message.recipients.length === 0) {
          return "To: (no recipients)"
        }
        // Format all recipients
        const recipientAddresses = message.recipients
          .map(recipient => this.formatRecipientEmail(recipient))
          .filter(addr => addr)
          .join(", ")
        return recipientAddresses ? `To: ${recipientAddresses}` : "To: (no recipients)"
      }
    },
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 Bytes"
      const k = 1024
      const sizes = ["Bytes", "KB", "MB", "GB"]
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + " " + sizes[i]
    },
    getAttachmentUrl(attachment) {
      const token = window.localStorage.getItem('session')
      const path = attachment.url
      const baseURL = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${path}` : path
      return `${baseURL}?token=${token}`
    },
    getIconForMimeType
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: grid;
  grid-template-columns: 40px 0.2fr 1fr 120px 120px 120px;
  align-items: center;
  gap: 20px;
  width: 100%;

  >.icon {
    grid-column: 1;
    justify-self: center;
  }

  >.from {
    grid-column: 2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  >.subject {
    grid-column: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .conversation-header-title {
    display: inline-flex;
    align-items: center;
  }

  >.sentiment-pill {
    grid-column: 4;
  }

  >.actions {
    grid-column: 5;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
  }

  >.date {
    grid-column: 6;
    text-align: right;
    padding-right: 20px;

  }
}

.message-header {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  align-items: start;
  min-height: auto;
}

.message-header-content {
  min-width: 0;
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachment-item {
  display: flex;
  align-items: stretch;
  min-height: 48px;
}

.attachment-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  padding: 8px;
  border-radius: 4px;
  margin-right: 12px;
}

.attachment-icon {
  color: white;
}

.attachment-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  padding: 0 !important;
}

.attachment-size {
  font-size: 12px;
  opacity: 0.7;
}

.message-header-info {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px 12px;
  align-items: start;
  row-gap: 4px;
}

.message-header-label {
  font-weight: 500;
  white-space: nowrap;
}

.message-header-value {
  text-align: left;
  word-break: break-word;
}

@media (max-width: 968px) {
  .header {
    grid-template-columns: 40px 1fr 120px 120px;
    grid-template-rows: auto auto;
    column-gap: 10px;
    row-gap: 0px;
    padding: 5px;

    >.icon {
      grid-column: 1;
      grid-row-start: 1;
      grid-row-end: 3;
      justify-self: center;
    }

    >.from {
      grid-column: 2;
      grid-row: 1;
      font-weight: 700;
    }

    >.subject {
      grid-column: 2;
      grid-row: 2;
      min-width: 0;
    }

    >.sentiment-pill {
      grid-column: 3;
      grid-row-start: 1;
      grid-row-end: 3;
    }

    >.actions {
      grid-column: 4;
      grid-row: 2;
      justify-content: flex-end;
    }

    >.date {
      grid-column: 4;
      grid-row: 1;
      text-align: right;
    }
  }
}
</style>
<style>
.sentiment.theme--dark.v-chip--disabled {
  color: rgba(255, 255, 255, 1);
}

.offset-top-sentiment {
  margin-top: -50px !important;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.offset-top-date {
  vertical-align: middle;
  margin-top: -5px
}

.v-expansion-panel__container--active.email-conversation .v-avatar.expansion-avatar.status:after {
  left: 0px;
}

.expansion-avatar.v-avatar.status:after {
  top: 2px;
  left: 1px;
}

.sentiment.header {
  margin-top: 3px !important;
  vertical-align: top;
}

.action-button {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 5px;
}

.unread {
  font-weight: 500;
}

.message-deleting {
  opacity: 0;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out, max-height 0.3s ease-out;
  transform: scale(0.95);
  pointer-events: none;
  max-height: 1000px;
  overflow: hidden;
}

.message-deleting.v-expansion-panel__container {
  margin: 0;
  padding: 0;
}
</style>
